<div class="row m-0 h-100 login_container">

  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 LoginBg setPadding ">
    <div class="row m-0 h-100 login">

      <div class="row_tab">
        <app-header></app-header>
        <div class="mainform">
          <div class="title col-12 align-self-center">
            <h3 class="mb-4"> RESET PASSWORD</h3>
          </div>
          <form class="blue_rectangle" [formGroup]="verifyPassword" *ngIf = "!emailVerified">
            <div class="row m-0">
              <div class="col-12 p-0 email">
                <mat-form-field class="col-12">
                  <input type="email" matInput placeholder="Email" formControlName="email" >

                </mat-form-field>
              </div>
              <div class="col-12">
                <div class="row align-items-center justify-content-center">
                  <div class="buttonpadding ">
                    <button class="btn_padding" [disabled]="!this.verifyPassword.valid"
                      mat-raised-button color="primaryCus" (click)="verifyEmail()">SUBMIT</button>
                  </div>
                  <div class="px-2 ml-auto">
                    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)"
                      [useGlobalDomain]="false" formControlName="recaptcha">
                    </ngx-recaptcha2>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form class="blue_rectangle" [formGroup]='resetPassword'  *ngIf = "emailVerified" >
            <div class="row m-0">
              <div class="col-12 p-0 onFocusPopup">
                <mat-form-field class="col-12">
                  <input type="password" matInput placeholder="Password" formControlName="password" [type]="hide ? 'password' : 'text'">
                  <span mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                      <mat-icon class="eyeview pointer">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </span>
                </mat-form-field>
                <div class="passwordIndicator changepos">
                  <ul>
                    <li [ngClass]="{'ValidPassword':resetPassword.get('password').errors?.hasUpperCase}">
                      <span>At least 1 upper case letters(A- Z)</span></li>
                    <li [ngClass]="{'ValidPassword':resetPassword.get('password').errors?.hasLowerCase}">
                      <span>At least 1 lower case letters(a-z)</span></li>
                    <li [ngClass]="{'ValidPassword':resetPassword.get('password').errors?.hasNumber}"><span> At
                        least 1 number(0-9)</span></li>
                    <li
                      [ngClass]="{'ValidPassword':(resetPassword.get('password').errors?.hasSymbol) || (resetPassword.get('password').errors?.hasSpace)}">
                      <span>At least 1 non-alphanumeric symbol (eg: '@$%')</span></li>
                    <li
                      [ngClass]="{'ValidPassword':resetPassword.get('password').errors?.required || resetPassword.get('password').errors?.minlength}">
                      <span>Minimum 8 characters</span></li>
                    <!-- <li [ngClass] = "{'ValidPassword':PersonalDetails.get('user_password').errors?.hasSpace}"><span>no space allowed</span></li> -->
                  </ul>
                </div>
              </div>
              <div class="col-12 p-0">
                <mat-form-field class="col-12" [ngClass] = "{'error-mat-undeline': confirmError}">
                  <input matInput type="password" placeholder="Confirm Password" [type]="hide2 ? 'password' : 'text'" formControlName='confirmPassword' [errorStateMatcher]="errorMatcher">
                  <span mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                      <mat-icon class="eyeview pointer">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                      </span>
                      <div class="error-mat" *ngIf="confirmError">Confirm password</div>
                  <mat-error *ngIf="resetPassword.hasError('passwordsDoNotMatch')">Password and confirm password
                    should be same
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12 ">
                <button class="btn_padding" [disabled]="!this.resetPassword.valid"
                mat-raised-button color="primaryCus" (click)="submitPassword()">SUBMIT</button>
              </div>
            </div>
          </form>
        </div>
      </div>
     <div class="col-12">
      <app-footer></app-footer>

     </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
    
    <app-sidescreen></app-sidescreen>

  </div>
</div>